import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { color } from '~/assets/styles/colors';
import { CardBody } from 'reactstrap';

export const StyledLink = styled(Link)`
	height: 60px;
	display: flex;
	align-items: center;
	padding-left: 20px;

	&:hover {
		text-decoration: none;
		background-color: ${color.yellow};
	}
`;

export const CardBodyDirf = styled(CardBody)`
	/* padding: 0; */
	/* border-right: 1 solid color.white; */
`;
